import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { Video } from '@/components/video';

export const InProgressScreen = ({
  title,
  description,
  src,
  alt,
  size,
}: {
  title: ReactNode;
  description?: string;
  src: string;
  alt: string;
  size: 'small' | 'large';
}) => {
  return (
    <Stack paddingX='100px' width='100%' justifyContent='center' height='100%'>
      <Stack
        gap={size === 'small' ? '24px' : '40px'}
        marginX='40px'
        alignItems='center'
        width={size === 'small' ? '320px' : '360px'}
        alignSelf='center'
        justifySelf='center'
      >
        <Video
          style={{
            borderRadius: '50%',
            objectFit: 'cover',
          }}
          src={src}
          alt={alt}
          width={size === 'small' ? 60 : 240}
          height={size === 'small' ? 60 : 240}
        />
        <Stack gap={size === 'small' ? '8px' : '12px'} alignItems='center'>
          {typeof title === 'string' ? (
            <Typography variant={size === 'small' ? 'subtitle1' : 'h3'}>
              {title}
            </Typography>
          ) : (
            title
          )}
          {description && (
            <Typography variant='body1' textAlign='center'>
              {description}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
